<template>
  <div>
    <BaseTitle :title="$t('content.change_storage')" />
    <v-card>
      <div class="pa-3">
        <div class="ml-5 mt-3 mr-5">
          <v-data-table
            :headers="tableHeader"
            :loading="table.loading"
            :items="items"
            hide-default-footer
            class="table-custom scroll"
            disable-pagination
          >
            <template #loading>
              <img src="@/assets/images/globe.gif" class="pa-4" />
            </template>

            <template #item.storageSize="{item}">
              <v-text-field
                type="number"
                v-number
                v-model="item.storageSize"
                @blur="storageInput(item)"
                :disabled="item.disabled"
                :min="0"
                suffix="MB"
              />
            </template>
            <template #item.option="{item}">
              <v-btn text @click="editItem(items.indexOf(item))" class="btn-action-custom"><svg-icon icon="edit" class="primary--text"/></v-btn>
            </template>
            <template #no-data><NoData /></template>
          </v-data-table>
          <v-divider class="mt-3 mb-3" />

          <div class="app-section-title">Total {{ $t('content.storage') }}</div>

          <div class="d-flex justify-center mt-6 mb-6">
            <v-avatar color="secondary" size="128"
              ><strong class="white--text">{{ sumTotal }} MB <br />Total</strong></v-avatar
            >
          </div>
          <div class="d-flex justify-center mt-3 mb-12">
            {{ $t('content.total_content') }}
          </div>
        </div>
      </div>
    </v-card>
    <div class="d-flex justify-end align-center mt-6">
      <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="backToList">{{ $t('back') }}</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import NoData from '@/components/table/NoData';

export default {
  name: 'MasterSchool',
  components: {
    BaseTitle,
    NoData
  },
  computed: {
    ...mapGetters({}),
    tableHeader() {
      return [
        { text: 'User Role', value: 'roleName' },
        { text: 'Storage Size', value: 'storageSize', width: 150 },
        { value: 'option', width: 10 }
      ];
    }
  },
  data: () => ({
    items: [],
    sumTotal: 0,
    table: {
      loading: false,
      options: {}
    }
  }),
  methods: {
    backToList() {
      this.$router.push({ name: 'MenuListLite' });
    },
    editItem(item) {
      this.items[item].disabled = false;
    },
    getData() {
      this.table.loading = true;
      this.$store
        .dispatch('Storage/fetchListLite')
        .then(data => {
          data.forEach(res => (res.disabled = true));
          this.sumTotal = data?.map(storage => storage?.storageSize).reduce((acc, storage) => storage + acc, 0);
          this.items = data;
        })
        .finally(() => (this.table.loading = false));
    },
    storageInput(items) {
      this.$store.dispatch(`Storage/update`, { ...items }).finally(() => this.getData());
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.border-item {
  border-bottom: 1px solid #dedede;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}

.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}

.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00BF63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
</style>
